// extracted by mini-css-extract-plugin
export default {"container":"Selection-module__container--VTcpJ","checkbox":"Selection-module__checkbox--nZsSH","checkboxCompact":"Selection-module__checkboxCompact--pRIwD"};